import { defineStore } from 'pinia'
import { ref } from 'vue'

const initialTag = [
  {
    fullPath: '/links',
    path: '/links',
    name: 'Links',
    meta: {
      title: '链接管理'
    }
  },
  {
    fullPath: '/assets',
    path: '/assets',
    name: 'Assets',
    meta: {
      title: '落地页'
    }
  }
]
export const useTagsStore = defineStore('tags', () => {
  const visitedTags = ref(JSON.parse(JSON.stringify(initialTag)))
  const cachedTags = ref(JSON.parse(JSON.stringify(initialTag)).map(v => v.fullPath))
  function addVisitedTags(route) {
    if (visitedTags.value.some(v => v.fullPath === route.fullPath)) return
    visitedTags.value.push(
      Object.assign({}, route)
    )
  }
  function addCachedTags(route) {
    if (cachedTags.value.includes(route.fullPath)) return
    cachedTags.value.push(route.fullPath)
  }

  function deleteVisitedTags(route) {
    let index
    visitedTags.value.forEach((v, i) => {
      if (v.fullPath === route.fullPath) {
        index = i
      }
    })

    if (index >= 0) {
      visitedTags.value.splice(index, 1)
    }
  }
  function deleteCachedTags(route) {
    if (cachedTags.value.indexOf(route.fullPath) !== -1) {
      cachedTags.value.splice(cachedTags.value.indexOf(route.fullPath), 1)
    }
  }

  function clearVisitedTags() {
    visitedTags.value = JSON.parse(JSON.stringify(initialTag))
    // visitedTags.value = []
  }
  function clearCachedTags() {
    cachedTags.value = []
  }
  function updateTagTitle(route, title) {
    const index = visitedTags.value.findIndex(v => v.fullPath === route.fullPath)
    if (index !== -1) {
      visitedTags.value[index].meta.title = title
    }
  }
  return {
    visitedTags,
    addVisitedTags,
    deleteVisitedTags,
    clearVisitedTags,
    cachedTags,
    addCachedTags,
    deleteCachedTags,
    clearCachedTags,
    updateTagTitle
  }
})